var projectTimeline = {
	"Project timeline": "الجدول الزمني للمشروع",
	"None planned": "لا شيء مخطط له",
	"1-3 months": "من شهر واحد إلى 3 أشهر",
	"4-6 months": "من 4 إلى 6 أشهر",
	"7-12 months": "من 7 إلى 12 شهرًا",
	"More than 1 year": "أكثر من سنة"
};

export { projectTimeline as default };
